import { pathway as pathway1 } from "./pathway-1.js"
import { pathway as pathway2 }  from "./pathway-2.js"
import { pathway as pathway3 } from "./pathway-3.js"
import { pathway as pathway4 } from "./pathway-4.js"
import { pathway as pathway5 } from "./pathway-5.js"
import { pathway as pathway6 } from "./pathway-6.js"
import { pathway as pathway7 } from "./pathway-7.js"

// console.log({pathway3});

export default {
    pathway1,
    pathway2,
    pathway3,
    pathway4,
    pathway5,
    pathway6,
    pathway7,
}
